module.exports = __webpack_public_path__ + "media/src/images/icons/brics-logo-passwords-4ca6cad2e5e9021563c85504fa9522c0.svg";